import { BuilderAnswerSwitch } from 'components/TasksV2/TaskCreation/components/BuilderAnswerSwitch'
import { useBuilderWidget } from 'components/TasksV2/TaskCreation/contexts/BuilderWidgetContext'
import { BuilderSubtaskSettings } from 'components/TasksV2/TaskCreation/components/BuilderSubtaskSettings'
import WidgetHeader from 'components/TasksV2/UI/WidgetHeader'
import { WidgetWrapper } from 'components/TasksV2/UI/WidgetWrapper'
import React, { memo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Flex } from '@chakra-ui/core'
import { useWidgetErrorMessage } from '../../useWidgetErrorMessage'
import { WidgetProps } from '../types'
import { OpenQuestion } from './Question'
import { WidgetIsRequiredSwitch } from '../WidgetIsRequiredSwitch'
import { CategorySelector } from '../CategorySelector'

const OpenQuestionWidget: React.FC<WidgetProps> = memo(({ index, isDragging, field, remove, subtaskPath }) => {
  const builder = useBuilderWidget()
  const { control, errors } = useFormContext()

  const error = useWidgetErrorMessage({ errors, index, field })

  return (
    <WidgetWrapper pos="relative" p="10px" isDragging={isDragging} isError={!!error} errorMessage={error}>
      <WidgetHeader onRemove={remove} subtaskType={field?.type} />

      <OpenQuestion
        subtaskPath={subtaskPath}
        field={field}
        headerAction={builder ? <BuilderAnswerSwitch subtaskPath={subtaskPath} numeric compact /> : undefined}
      />

      {builder ? (
        <BuilderSubtaskSettings subtaskPath={subtaskPath} />
      ) : (
        <Flex w="100%" alignItems="center" flexDir="row" justifyContent="space-between">
          {/* Category Selector */}
          <CategorySelector subtaskPath={subtaskPath} />
          <WidgetIsRequiredSwitch subtaskPath={subtaskPath} />
        </Flex>
      )}

      {/*Register constant values in the form context*/}
      <Controller
        name={`${subtaskPath}.type`}
        control={control}
        as={<Box />}
        key={`${subtaskPath}.type`}
        defaultValue={field?.type}
      />
    </WidgetWrapper>
  )
})

export default OpenQuestionWidget
